import React from 'react';
import { SemOuterTrackWrapper } from './styles';

type OwnProps = {
  sectionName: string;
  children: React.JSX.Element;
};

const SemTrackWrapper = ({ children, sectionName }: OwnProps) => {
  return (
    <SemOuterTrackWrapper
      event={{ eventName: `ViewedSection - ${sectionName}` }}
      visiblePercentage={0.33}
      trackOnce
    >
      {children}
    </SemOuterTrackWrapper>
  );
};

export default SemTrackWrapper;
